(() => {
  const GROUP_SELECTOR =
    '[data-gvs-compatibility-carousel]';

  const getGap = (track) => {
    const styles =
      window.getComputedStyle(track);

    const value = parseFloat(
      styles.columnGap ||
        styles.gap ||
        '0'
    );

    return Number.isFinite(value)
      ? value
      : 0;
  };

  const initialiseCarousel = (group) => {
    if (
      group.dataset
        .gvsCompatibilityInitialised ===
      'true'
    ) {
      return;
    }

    const track = group.querySelector(
      '[data-gvs-compatibility-track]'
    );

    const cards = Array.from(
      track?.querySelectorAll(
        '.gvs-compatibility__card'
      ) || []
    );

    const controls = group.querySelector(
      '[data-gvs-compatibility-controls]'
    );

    const status = group.querySelector(
      '[data-gvs-compatibility-status]'
    );

    const previousButton =
      group.querySelector(
        '[data-gvs-compatibility-previous]'
      );

    const nextButton =
      group.querySelector(
        '[data-gvs-compatibility-next]'
      );

    if (!track || cards.length === 0) {
      return;
    }

    let frame = null;

    const getMetrics = () => {
      const firstCard = cards[0];

      const cardWidth =
        firstCard
          ?.getBoundingClientRect()
          .width || 0;

      const gap = getGap(track);
      const step = cardWidth + gap;

      const visibleCount =
        step > 0
          ? Math.max(
              1,
              Math.round(
                (track.clientWidth + gap) /
                  step
              )
            )
          : 1;

      const maximumScroll = Math.max(
        0,
        track.scrollWidth -
          track.clientWidth
      );

      const firstIndex =
        step > 0
          ? Math.min(
              cards.length - 1,
              Math.max(
                0,
                Math.round(
                  track.scrollLeft / step
                )
              )
            )
          : 0;

      return {
        gap,
        step,
        visibleCount,
        maximumScroll,
        firstIndex
      };
    };

    const update = () => {
      frame = null;

      const metrics = getMetrics();

      const isScrollable =
        metrics.maximumScroll > 2;

      const atStart =
        track.scrollLeft <= 2;

      const atEnd =
        track.scrollLeft >=
        metrics.maximumScroll - 2;

      group.classList.toggle(
        'is-scrollable',
        isScrollable
      );

      track.tabIndex = isScrollable
        ? 0
        : -1;

      if (controls) {
        controls.hidden = !isScrollable;
      }

      if (previousButton) {
        previousButton.disabled =
          !isScrollable || atStart;
      }

      if (nextButton) {
        nextButton.disabled =
          !isScrollable || atEnd;
      }

      if (status) {
        const firstVisible =
          metrics.firstIndex + 1;

        const lastVisible = Math.min(
          cards.length,
          metrics.firstIndex +
            metrics.visibleCount
        );

        const isMobile = window
          .matchMedia(
            '(max-width: 749px)'
          )
          .matches;

        status.textContent =
          isMobile ||
          firstVisible === lastVisible
            ? `${firstVisible} of ${cards.length}`
            : `${firstVisible}–${lastVisible} of ${cards.length}`;
      }
    };

    const requestUpdate = () => {
      if (frame !== null) {
        return;
      }

      frame =
        window.requestAnimationFrame(
          update
        );
    };

    const scrollByPage = (direction) => {
      const metrics = getMetrics();

      const cardStep =
        metrics.step ||
        track.clientWidth;

      const pageSize = Math.max(
        1,
        metrics.visibleCount
      );

      track.scrollBy({
        left:
          direction *
          cardStep *
          pageSize,
        behavior: window
          .matchMedia(
            '(prefers-reduced-motion: reduce)'
          )
          .matches
          ? 'auto'
          : 'smooth'
      });
    };

    previousButton?.addEventListener(
      'click',
      () => scrollByPage(-1)
    );

    nextButton?.addEventListener(
      'click',
      () => scrollByPage(1)
    );

    track.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );

    track.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key !== 'ArrowLeft' &&
          event.key !== 'ArrowRight'
        ) {
          return;
        }

        const metrics = getMetrics();

        if (
          metrics.maximumScroll <= 2
        ) {
          return;
        }

        event.preventDefault();

        scrollByPage(
          event.key === 'ArrowRight'
            ? 1
            : -1
        );
      }
    );

    if ('ResizeObserver' in window) {
      const resizeObserver =
        new ResizeObserver(
          requestUpdate
        );

      resizeObserver.observe(track);

      cards.forEach((card) => {
        resizeObserver.observe(card);
      });
    } else {
      window.addEventListener(
        'resize',
        requestUpdate,
        {
          passive: true
        }
      );
    }

    group.dataset
      .gvsCompatibilityInitialised =
      'true';

    group.gvsCompatibilityUpdate =
      requestUpdate;

    requestUpdate();

    window.addEventListener(
      'load',
      requestUpdate,
      {
        once: true
      }
    );
  };

  const initialiseAll = (
    scope = document
  ) => {
    if (
      scope.matches?.(GROUP_SELECTOR)
    ) {
      initialiseCarousel(scope);
    }

    scope
      .querySelectorAll?.(
        GROUP_SELECTOR
      )
      .forEach(
        initialiseCarousel
      );
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialiseAll()
    );
  } else {
    initialiseAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      window.requestAnimationFrame(
        () =>
          initialiseAll(
            event.target ||
              document
          )
      );
    }
  );

  document.addEventListener(
    'gvs:product-tab:shown',
    (event) => {
      event.target
        .querySelectorAll?.(
          GROUP_SELECTOR
        )
        .forEach((group) => {
          group.gvsCompatibilityUpdate?.();
        });
    }
  );
})();